export default __webpack_public_path__ + "static/ensalada-cb8df8abccb403a8e15c672997dc7a09.jpg";